import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import SubNavigation from '../../../components/SubNavigation';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';

import './styles.css';
//import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  const questions = {
    //title: 'Question 6: Boundaries',
    type: 'multiple',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Which of the following are outcomes of acknowledging your limitations? select all that apply`}
        />
        <strong>
          Which of the following are outcomes of acknowledging your limitations?
        </strong>
        <br />
        (select all that apply)
      </Fragment>
    ),
    result: ['A', 'B', 'D', 'F', 'G'],
    feedback: {
      correct: 'Correct! Acknowledging the limits of your role and abilities are ways to protect your wellbeing and ensure that the person gets connected with supports that are best equipped to help. Sharing that you recognize this is beyond your role and that you may not have the necessary knowledge or experience allows you to be honest and facilitate appropriate referrals.',
      incorrectNode:
        <div>
          <p>The correct answers are A, B, D, F & G.  By not acknowledging your limits, you run the risk of
          becoming someone’s sole source of support. This may prevent them from getting the help they need and
          can lead you to feel overburdened and resentful.
        </p>
          <p>
            Acknowledging the limits of your role and abilities are ways to protect your wellbeing and ensure that the
            person gets connected with supports that are best equipped to help. Sharing that you recognize this
            is beyond your role and that you may not have the necessary knowledge or experience allows you to be honest
            and facilitate appropriate referrals.
        </p>
        </div>,
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: 'correct',
      optionText:
        'Facilitating a connection to resources and services'
    },
    {
      prefix: 'B',
      result: 'correct',
      optionText: 'Avoiding burn out'
    },
    {
      prefix: 'C',
      result: 'incorrect',
      optionText:
        'Avoiding resentment'
    },
    {
      prefix: 'D',
      result: 'correct',
      optionText:
        'Reducing the amount of time and energy you feel you need to invest'
    },
    {
      prefix: 'E',
      result: 'incorrect',
      optionText: "Becoming someone's primary source of support beyond your role"
    },
    {
      prefix: 'F',
      result: 'correct',
      optionText: 'Refraining from taking on responsibility beyond your role'
    },
    {
      prefix: 'G',
      result: 'correct',
      optionText: 'Preventing yourself from "taking on" the problem disclosed'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={2}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`1. Acknowledge limitations`}
              />
              <h2 className="txt-blue no-bold no-margin">
                1. Acknowledge limitations
              </h2>
            </Col>
          </Row>
          {/* <SubNavigation
            activeList={['Acknowledge']}
            currentHeading={['Acknowledge']}
          /> */}
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`It’s important to acknowledge your own limitations in how you can help. Explaining those limitations justifies referrals to other resources and services that are better positioned and equipped to support someone. For example, you might say “I’m not sure what options are available for your situation but I can connect you to some people who know.”`}
              />
              <p>
                It’s important to acknowledge your own limitations in how you can help. Explaining those
                limitations justifies referrals to other resources and services that are better positioned
                and equipped to support someone. For example, you might say {' '}
                <span className="font-italic">
                  “I’m not sure what options are available for your situation but I can connect you to some people who know.”
                </span>
              </p>
              <p>
                Acknowledging your limits also protects you. Work through the following activity to learn of possible outcomes
                to acknowledging your limitations.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="refer"
        nextRoute={url.REFER_C}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferB = connect.role(ReferPage);

export default ReferB;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferB/index.jsx